import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  WORKFLOW,
  WORKFLOW_STEP,
  WORKFLOW_STEP_CONFIGURATION,
  WORKFLOW_TABLE,
  WORKFLOW_STEP_TABLE,
  WORKFLOW_STEP_CONFIGURATION_TABLE,
  MATCHING_RULES,
  RULES,
  ADDED,
  MODIFIED,
  REQUEST_STATE,
} = STATE_IDENTIFIER;

export default {
  [WORKFLOW]: {
    [WORKFLOW_TABLE]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
  },
  [WORKFLOW_STEP]: {
    [WORKFLOW_STEP_TABLE]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
  },
  [WORKFLOW_STEP_CONFIGURATION]: {
    [WORKFLOW_STEP_CONFIGURATION_TABLE]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
  },
  [MATCHING_RULES]: {
    [RULES]: [],
    [LOADER_IDENTIFIER]: false,
    [REQUEST_STATE]: IResponseState.PENDING,
  },
  [REQUEST_STATE]: IResponseState.PENDING,
};
